import { Request } from '@ecoflow/ef-device-core';
import { SITE_MAP, DEFAULT_SITE, LOCALSTORAGE_SELECTED_SITE } from '@ecoflow/ef-device-core/src/constants';
import type { SiteType } from '@ecoflow/ef-device-core/src/constants';
import { getCurrentSite } from '@ecoflow/ef-device-core/src/lib/i18n';
import ConfigType from './apis';
import headerHandle from './headerHandle';
import errorHandle from './errorHandle';
import { localStoreData } from '@ecoflow/ef-device-core/src/utils';

// 确定访问数据中心
const site = getCurrentSite(2) as SiteType;
const [localSite] = localStoreData<string>(LOCALSTORAGE_SELECTED_SITE);
const API_HOST = SITE_MAP[site || localSite || DEFAULT_SITE];

export default new Request<typeof ConfigType>({
    baseURL: API_HOST,
    interceptorsReq: (config) => {
        Object.assign(config.headers, headerHandle());
    },
    interceptorsResError: (error) => {
        return errorHandle(error);
    },
});
